var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-56c978a8-1a61-434c-a04a-8819123f2bd6",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-674b490f-ca29-46c3-be05-8079a2e6c1b1 {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-674b490f-ca29-46c3-be05-8079a2e6c1b1",
    d: "M9.2,13.79l6.83,9.76h3.04l-6.84-9.76h-3.04ZM12.23,19.21l-3.04,4.34h3.04l1.52-2.17-1.52-2.17ZM19.77,8.45l-5.25,7.5,1.52,2.17,6.77-9.67h-3.04ZM20.32,13.09v10.46h2.49v-14.01l-2.49,3.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXI);
export default __webpack_public_path__ + "static/media/xI.71d6f2c9a7c6d972430e56bda27f8d76.svg";
export { ForwardRef as ReactComponent };